import React, { useContext } from 'react';
var _configContext = React.createContext({});
export var ConfigContextProvider = _configContext.Provider;
export var ConfigContextConsumer = _configContext.Consumer;
export var useConfigContext = function () {
    return useContext(_configContext);
};
//# sourceMappingURL=config-context.js.map